import { Link, List, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Modal } from '../../../../../components/Modal/Modal.component';
import { SessionImagesFileUploadItem } from '../SessionImagesFileUploadListItem/SessionImagesFileUploadItem.component';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { ButtonOne } from '../../../../../components/ButtonOne/ButtonOne.component';
import { Prompt } from '../../../../../components/Prompt/Prompt.component';
import { useLayoutContext } from '../../../../../Context/Layout.context';
import {
  UploadingFileWithOptions,
  SessionImagesFileUploadListProps,
} from '../SessionImagesFileUpload/SessionImagesFileUpload.types';
import { deleteSheetPage } from '../../../../../services/exams/sessions/sessions.service';
import { AxiosError } from 'axios';

export const SessionImagesFileUploadList: React.FC<SessionImagesFileUploadListProps> = ({
  files,
  refreshData,
  sheetId,
  onAbort,
}) => {
  const [isLeavePromptOpen, setIsLeavePromptOpen] = useState<boolean>(false);
  const [filesList, setFilesList] = useState<UploadingFileWithOptions[]>([]);
  const { openAlert } = useLayoutContext();

  const filesToUpload: UploadingFileWithOptions[] = [];
  const allFiles: UploadingFileWithOptions[] = [];

  useEffect(() => {
    setFilesList(files);
  }, [files]);

  filesList.forEach((f: UploadingFileWithOptions) => {
    if (f.isUploading) {
      allFiles.push(f);
    }
    if (f.isUploading && !f.error) {
      filesToUpload.push(f);
    }
  });

  const handleDeleteSheetPage = (sheetId: string, pageList: number[]) => {
    deleteSheetPage(sheetId, pageList).then(
      () => {
        setFilesList([]);
        openAlert('error', 'Dodanie wzorcowego arkusza nie powiodło się, przerwano import plików');
        refreshData();
      },
      (error: AxiosError) => {
        console.error(error);
      },
    );
  };

  const pageNumber = filesToUpload.map((file) => {
    return +file.name.split('_')[0];
  });

  const handleClose = () => {
    setIsLeavePromptOpen(false);
    setFilesList([]);
    onAbort?.();
    if (pageNumber.length > 0) {
      handleDeleteSheetPage(sheetId, pageNumber);
    }
  };

  const handleConfirmation = () => {
    setIsLeavePromptOpen(false);
    setFilesList([]);
    if (filesToUpload.length > 0) {
      openAlert('success', 'Wzorcowy arkusz został dodany pomyślnie');
      refreshData();
    }
  };

  return (
    <>
      {filesList.length > 0 && (
        <Modal open={true} size="md" handleClose={handleClose}>
          <div>
            <Link
              component="button"
              variant="body2"
              onClick={() => setIsLeavePromptOpen(true)}
              style={{ display: 'flex', alignItems: 'flex-end', fontWeight: 700 }}
            >
              <ArrowLeftIcon fontSize="medium" />
              Wzorcowy arkusz
            </Link>
            <div
              style={{ display: 'flex', flexDirection: 'column', margin: '30px auto', width: '600px', height: '390px' }}
            >
              <Typography style={{ fontWeight: '700', textAlign: 'center', fontSize: '1.25em' }}>
                Importuję pliki
              </Typography>
              <List style={{ overflow: 'auto', height: '390px' }}>
                {filesList.length > 0 &&
                  filesList.map((f: UploadingFileWithOptions) => (
                    <SessionImagesFileUploadItem
                      key={f.name}
                      file={f}
                      isUploading={f.isUploading}
                      name={f.name}
                      error={f.error}
                    />
                  ))}
              </List>
            </div>
            <div style={{ position: 'absolute', right: '20px', bottom: '20px', display: 'inline-flex' }}>
              {files.length !== allFiles.length && (
                <>
                  <Typography style={{ padding: '8px', marginRight: '10px', fontWeight: 700 }}>
                    Importuję {filesToUpload.length} z {files.length} plików...
                  </Typography>
                  <ButtonOne
                    onClick={() => setIsLeavePromptOpen(true)}
                    variant="outlined"
                    style={{ color: 'red', border: '1px solid red', fontWeight: 700 }}
                  >
                    Anuluj Import Plików
                  </ButtonOne>
                </>
              )}
              {files.length === allFiles.length && (
                <>
                  <Typography style={{ padding: '8px', marginRight: '10px', fontWeight: 700 }}>
                    {filesToUpload.length} z {files.length} plików zaimportowano pomyślnie.
                  </Typography>
                  <ButtonOne
                    onClick={handleConfirmation}
                    style={{
                      backgroundColor: 'green',
                      border: '1px solid green',
                      color: 'white',
                      fontWeight: 500,
                      paddingLeft: '20px',
                      paddingRight: '20px',
                    }}
                  >
                    Gotowe
                  </ButtonOne>
                </>
              )}
            </div>
          </div>
        </Modal>
      )}
      <Prompt
        type="confirmation"
        isBold={true}
        size={'xs'}
        open={isLeavePromptOpen}
        mainText="Czy na pewno chcesz przerwać import plików?"
        subTexts={[{ text: 'Wprowadzone dane nie zostaną zapisane.' }]}
        mainActionButtonText="Tak"
        onConfirm={handleClose}
        onCancel={() => setIsLeavePromptOpen(false)}
      />
    </>
  );
};
